module.exports = __webpack_public_path__ + "img/kontaktio.919b56f0.png";